import { CloudLarge, CloudMedium, CloudSmall } from "../../components/images";

export const StoryElementsData = {
  title: "Elements of Story Writing",
  introduction:
    "Welcome to term 2 of Writers Club. Are you excited for this amazing journey? Over the next week, we will be practicing the different elements of story writing. Our aim is to make stories more interesting and exciting.",
  description:
    "There are five elements which make the foundation for story writing. An element is an essential part of something and every fiction story has the same key elements:",
  elements: [
    {
      name: "Settings",
      cloud: CloudMedium,
    },
    {
      name: "Characters",
      cloud: CloudLarge,
    },
    {
      name: "Plot",
      cloud: CloudMedium,
    },
    {
      name: "Problem or conflict",
      cloud: CloudSmall,
    },
    {
      name: "Resolution",
      cloud: CloudLarge,
    },
  ],
  conclusion:
    "You must be familiar with some of these. If not, do not worry! we will cover all these elements as we go along.",
  footer: {
    points: [
      "For today’s lesson, we will try to understand and practice writing the setting for our stories.",
      "The setting is an important element of every fiction story.",
    ],
  },
};
